import { InlineIcon } from '@iconify/react';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
import styles from './NavArrow.module.scss';

interface Props {
  goToPrevious?: () => void;
  goToNext?: () => void;
  disabled?: boolean;
}

const NavArrowLeft = ({ goToPrevious }: Props): JSX.Element => {
  return (
    <button className={styles.navArrow} onClick={goToPrevious}>
      <InlineIcon icon={arrowIosBackFill} width={24} />
    </button>
  );
};

const NavArrowRight = ({ goToNext, disabled }: Props): JSX.Element => {
  return (
    <button className={styles.navArrow} onClick={goToNext} disabled={disabled}>
      <InlineIcon icon={arrowIosForwardFill} width={24} />
    </button>
  );
};

const EmptyBlock = (): JSX.Element => {
  return <div className={styles.emptyBlock} />;
};

export { NavArrowLeft, NavArrowRight, EmptyBlock };
